import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      width={500}
      height={372.61}
      viewBox="0 0 500 372.61"
      {...props}
    >
      <g data-name="Background Complete">
        <path
          data-name="Rectangle 1862"
          fill="#ebebeb"
          d="M0 327.45h500v.25H0z"
        />
        <path
          data-name="Rectangle 1863"
          fill="#ebebeb"
          d="M290.21 334.26h25.46v.25h-25.46z"
        />
        <path
          data-name="Rectangle 1864"
          fill="#ebebeb"
          d="M395.11 339.67h60.33v.25h-60.33z"
        />
        <path
          data-name="Rectangle 1865"
          fill="#ebebeb"
          d="M222.46 334.38h62.33v.25h-62.33z"
        />
        <path
          data-name="Rectangle 1866"
          fill="#ebebeb"
          d="M169 341.86h13.04v.25H169z"
        />
        <path
          data-name="Rectangle 1867"
          fill="#ebebeb"
          d="M194.71 341.86h59.38v.25h-59.38z"
        />
        <path
          data-name="Rectangle 1868"
          fill="#ebebeb"
          d="M52.46 337.64h38.45v.25H52.46z"
        />
        <path
          data-name="Path 11727"
          d="M237 282.85H43.91a5.71 5.71 0 01-5.7-5.71V5.71A5.71 5.71 0 0143.91 0H237a5.71 5.71 0 015.71 5.71v271.43a5.71 5.71 0 01-5.71 5.71zM43.91.25a5.46 5.46 0 00-5.45 5.46v271.43a5.46 5.46 0 005.45 5.46H237a5.47 5.47 0 005.46-5.46V5.71A5.47 5.47 0 00237 .25z"
          fill="#ebebeb"
        />
        <path
          data-name="Path 11728"
          d="M453.31 282.85h-193.1a5.72 5.72 0 01-5.71-5.71V5.71A5.72 5.72 0 01260.21 0h193.1A5.71 5.71 0 01459 5.71v271.43a5.71 5.71 0 01-5.69 5.71zM260.21.25a5.47 5.47 0 00-5.46 5.46v271.43a5.47 5.47 0 005.46 5.46h193.1a5.47 5.47 0 005.46-5.46V5.71a5.47 5.47 0 00-5.46-5.46z"
          fill="#ebebeb"
        />
        <path
          data-name="Path 11729"
          d="M195.96 240.71h-66.4l-4.03-46.5h66.4z"
          fill="#e6e6e6"
        />
        <path
          data-name="Path 11730"
          d="M199.4 240.71H133l-4.03-46.5h66.4z"
          fill="#f0f0f0"
        />
        <path
          data-name="Path 11731"
          d="M142.08 230.73l-2.22-26.53h46.43l2.22 26.53z"
          fill="#fff"
        />
        <path
          data-name="Rectangle 1869"
          fill="#e6e6e6"
          d="M203.1 240.71h7.79v86.73h-7.79z"
        />
        <path
          data-name="Rectangle 1870"
          fill="#f0f0f0"
          d="M207.94 240.71h5.41v86.73h-5.41z"
        />
        <path
          data-name="Rectangle 1871"
          fill="#f0f0f0"
          d="M213.35 250.29h-75.41v-9.57h75.41z"
        />
        <path
          data-name="Rectangle 1872"
          fill="#e6e6e6"
          d="M132.81 250.29h7.79v77.16h-7.79z"
        />
        <path
          data-name="Rectangle 1873"
          fill="#f0f0f0"
          d="M137.65 250.29h5.41v77.16h-5.41z"
        />
        <path
          data-name="Rectangle 1874"
          fill="#e6e6e6"
          d="M77.36 250.29h7.79v77.16h-7.79z"
        />
        <path
          data-name="Rectangle 1875"
          fill="#f0f0f0"
          d="M82.2 250.29h5.41v77.16H82.2z"
        />
        <path
          data-name="Rectangle 1876"
          fill="#e6e6e6"
          d="M153.8 250.29h7.79v77.16h-7.79z"
        />
        <path
          data-name="Rectangle 1877"
          fill="#f0f0f0"
          d="M158.63 250.29h5.41v77.16h-5.41z"
        />
        <path
          data-name="Rectangle 1878"
          fill="#e6e6e6"
          d="M77.36 240.71h60.58v9.57H77.36z"
        />
        <path
          data-name="Rectangle 1879"
          fill="#e0e0e0"
          d="M129.51 24.46h234.33v130.46H129.51z"
        />
        <path
          data-name="Rectangle 1880"
          fill="#f5f5f5"
          d="M130.69 24.46h246.02v130.46H130.69z"
        />
        <path
          data-name="Rectangle 1881"
          fill="#fff"
          d="M372.69 28.48V150.9H134.71V28.48z"
        />
        <path
          data-name="Path 11732"
          d="M231.07 150.9L276 28.48h-74.15L156.92 150.9z"
          fill="#f5f5f5"
        />
        <path
          data-name="Path 11733"
          d="M302.44 150.9l44.93-122.42h-55.94L246.5 150.9z"
          fill="#f5f5f5"
        />
        <path
          data-name="Rectangle 1882"
          fill="#e6e6e6"
          d="M418.19 202.85h19.92v124.6h-19.92z"
        />
        <path
          data-name="Path 11734"
          d="M432.87 327.45h5.24v-9.6h-10.73z"
          fill="#fafafa"
        />
        <path
          data-name="Rectangle 1883"
          fill="#e6e6e6"
          d="M234.53 202.85h19.92v124.6h-19.92z"
        />
        <path
          data-name="Rectangle 1884"
          fill="#fafafa"
          d="M249.88 202.85h188.23v122.01H249.88z"
        />
        <path
          data-name="Path 11735"
          d="M434.55 242.22h-181.1v-34.46h181.1zm-180.1-1h179.1v-32.46h-179.1z"
          fill="#e6e6e6"
        />
        <path
          data-name="Path 11736"
          d="M402.67 224.49H288.84c-5.28 0-10.37-4.27-14-11.7l-.34-.72H417l-.34.72c-3.66 7.43-8.66 11.7-13.99 11.7zm-126.53-11.42c3.38 6.63 8 10.42 12.7 10.42h113.83c4.72 0 9.32-3.79 12.7-10.42z"
          fill="#e6e6e6"
        />
        <path
          data-name="Path 11737"
          d="M255.12 327.45h-5.24v-9.6h10.73z"
          fill="#fafafa"
        />
        <path
          data-name="Path 11738"
          d="M434.55 281.08h-181.1v-34.46h181.1zm-180.1-1h179.1v-32.46h-179.1z"
          fill="#e6e6e6"
        />
        <path
          data-name="Path 11739"
          d="M402.67 263.35H288.84c-5.28 0-10.37-4.26-14-11.69l-.34-.72H417l-.34.72c-3.66 7.43-8.66 11.69-13.99 11.69zm-126.53-11.41c3.38 6.63 8 10.41 12.7 10.41h113.83c4.72 0 9.32-3.78 12.7-10.41z"
          fill="#e6e6e6"
        />
        <path
          data-name="Path 11740"
          d="M434.55 320h-181.1v-34.51h181.1zm-180.1-1h179.1v-32.51h-179.1z"
          fill="#e6e6e6"
        />
        <path
          data-name="Path 11741"
          d="M402.67 302.22H288.84c-5.28 0-10.37-4.26-14-11.7l-.34-.71H417l-.34.71c-3.66 7.48-8.66 11.7-13.99 11.7zm-126.53-11.41c3.38 6.63 8 10.41 12.7 10.41h113.83c4.72 0 9.32-3.78 12.7-10.41z"
          fill="#e6e6e6"
        />
        <path
          data-name="Path 11742"
          d="M120.98 219.33v2.42h-1.54l-1.28 18.96H99.32l-1.27-18.96H96.5v-2.42z"
          fill="#e6e6e6"
        />
        <path
          data-name="Path 11743"
          d="M114.78 172.26C113.24 161 98 157.73 78.64 157.32c-18.41-.39-24.31-6.91-24.31-6.91s.06 26.38 26.59 35.93c25.19 9.07 35.41-2.76 33.86-14.08z"
          fill="#e6e6e6"
        />
        <path
          data-name="Path 11744"
          d="M105.38 197.87c.32-4.65 7.74-13.18 25.59-9.3 12.9 2.8 17.7-3.88 17.7-3.88s-1.2 18.87-20.6 24.55c-18.43 5.39-23.26-3.24-22.69-11.37z"
          fill="#e6e6e6"
        />
        <path
          data-name="Path 11745"
          d="M109.45 226.45a.69.69 0 00.53-.24c1.29-1.53.23-5.19-1.23-10.26-1.88-6.5-4.22-14.6-2.24-20.48a83 83 0 013.84-9.07c2.8-5.92 5.22-11 3.2-16.38a.68.68 0 00-.89-.4.7.7 0 00-.4.89c1.81 4.79-.38 9.43-3.16 15.3a86.459 86.459 0 00-3.9 9.22c-2.11 6.29.29 14.61 2.22 21.3 1.14 3.94 2.32 8 1.51 9a.68.68 0 00.08 1 .66.66 0 00.44.12z"
          fill="#e6e6e6"
        />
      </g>
      <ellipse
        data-name="&lt;Path&gt;"
        cx={193.89}
        cy={11.32}
        rx={193.89}
        ry={11.32}
        transform="translate(56.11 349.97)"
        fill="#f5f5f5"
      />
      <path
        data-name="Path 11746"
        d="M249.96 306.1h-142l-7.77-228.37h142z"
        fill="#407bff"
      />
      <path
        data-name="Path 11747"
        d="M257.05 299.01h-142l-7.78-228.37h142z"
        fill="#407bff"
      />
      <path
        data-name="Path 11748"
        d="M257.05 299.01h-142l-7.78-228.37h142z"
        fill="#fff"
        opacity={0.3}
      />
      <ellipse
        data-name="Ellipse 599"
        cx={39.27}
        cy={40.63}
        rx={39.27}
        ry={40.63}
        transform="rotate(-45.5 223.822 -80.05)"
        fill="#407bff"
      />
      <path
        data-name="Path 11749"
        d="M213.47 136.14a32.06 32.06 0 01-3.45 15.7 31.61 31.61 0 01-28.4 17.26 34.28 34.28 0 01-29.56-17.26 33.52 33.52 0 01-4.52-15.7 31.64 31.64 0 0131.84-33 34.36 34.36 0 0134.09 33z"
        fill="#fff"
      />
      <path
        data-name="Path 11750"
        d="M210 151.84a31.61 31.61 0 01-28.4 17.26 34.28 34.28 0 01-29.56-17.26 50.51 50.51 0 0128.68-8.78 53.4 53.4 0 0129.28 8.78z"
        fill="#407bff"
        opacity={0.6}
      />
      <ellipse
        data-name="Ellipse 600"
        cx={14.44}
        cy={14.94}
        rx={14.44}
        ry={14.94}
        transform="rotate(-45.5 228.4 -127.703)"
        fill="#407bff"
        opacity={0.6}
      />
      <path
        data-name="Path 11751"
        d="M228.52 216.31h-90.58l-.61-18h90.58z"
        fill="#fff"
      />
      <path
        data-name="Path 11752"
        d="M229.62 248.48h-90.59l-.61-18h90.59z"
        fill="#fff"
      />
      <path
        data-name="Path 11753"
        d="M194.66 233l-21.83 3a1.53 1.53 0 00-1.32 1.81l2.87 14.63a1.75 1.75 0 001.94 1.36l21.83-3a1.52 1.52 0 001.31-1.8l-2.86-14.63a1.74 1.74 0 00-1.94-1.37zm-6.27 14.81l-4 .54-.39-4.72a2.82 2.82 0 01-1.63-2 2.49 2.49 0 012.16-3 2.86 2.86 0 013.16 2.23 2.42 2.42 0 01-.78 2.32z"
        fill="#ffb921"
      />
      <path
        data-name="Path 11754"
        d="M192.5 232.17a1.56 1.56 0 01-1.72-1.21l-.28-1.43a8.23 8.23 0 00-8.62-6.56 7 7 0 00-6.46 8.39l.32 1.65a1.35 1.35 0 01-1.17 1.6 1.54 1.54 0 01-1.72-1.21l-.27-1.4a9.84 9.84 0 018-11.74 11.19 11.19 0 0112.8 8.66l.32 1.65a1.35 1.35 0 01-1.2 1.6z"
        fill="#ffb921"
      />
      <path
        data-name="Path 11755"
        d="M214.67 273.69H155.7l-.39-11.72h58.96z"
        fill="#18206b"
      />
      <path
        data-name="Path 11756"
        d="M186.22 207.31a3.16 3.16 0 01-3.22 3.29 3.44 3.44 0 01-3.41-3.29 3.16 3.16 0 013.18-3.29 3.43 3.43 0 013.45 3.29z"
        fill="#263238"
      />
      <path
        data-name="Path 11757"
        d="M172 207.31a3.15 3.15 0 01-3.18 3.29 3.43 3.43 0 01-3.4-3.29 3.16 3.16 0 013.18-3.29 3.42 3.42 0 013.4 3.29z"
        fill="#263238"
      />
      <path
        data-name="Path 11758"
        d="M157.87 207.31a3.16 3.16 0 01-3.18 3.29 3.42 3.42 0 01-3.4-3.29 3.16 3.16 0 013.18-3.29 3.42 3.42 0 013.4 3.29z"
        fill="#263238"
      />
      <path
        data-name="Path 11759"
        d="M200.39 207.31a3.16 3.16 0 01-3.18 3.29 3.42 3.42 0 01-3.4-3.29A3.15 3.15 0 01197 204a3.42 3.42 0 013.39 3.31z"
        fill="#263238"
      />
      <path
        data-name="Path 11760"
        d="M214.56 207.31a3.15 3.15 0 01-3.18 3.29 3.43 3.43 0 01-3.4-3.29 3.16 3.16 0 013.18-3.29 3.42 3.42 0 013.4 3.29z"
        fill="#263238"
      />
      <g>
        <path
          data-name="Path 11761"
          d="M333.91 119.33c1.33 2.13 2.44 4.18 3.58 6.31s2.17 4.27 3.18 6.46a92.358 92.358 0 015.1 13.73c.18.59.31 1.22.46 1.83l.22.93.11.46.13.76a13.629 13.629 0 01-.31 5.15 29.159 29.159 0 01-3.12 7.46 59.219 59.219 0 01-8.88 11.67l-4.21-3.19a111.243 111.243 0 005.63-12 25.139 25.139 0 001.53-5.63 4.44 4.44 0 00-.08-1.77l-.4-1.22c-.16-.51-.31-1-.5-1.51a112.534 112.534 0 00-5.27-12.08c-2-4-4.15-8-6.3-11.82z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11762"
          d="M331.24 169.47l-4.6 2.44 5.28 6.18s3.3-2.23 3.45-5.63z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11763"
          d="M320.47 175.72l5.65 4.49 5.8-2.12-5.28-6.18z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11764"
          d="M301.15 86.61c-.11.56-.5 1-.86.87a.944.944 0 01-.46-1.14c.11-.56.5-.94.87-.87s.56.59.45 1.14z"
          fill="#263238"
        />
        <path
          data-name="Path 11765"
          d="M300.7 87.57a20 20 0 01-3.62 4.21 3.28 3.28 0 002.56 1z"
          fill="#ff5652"
        />
        <path
          data-name="Path 11766"
          d="M298.9 107.19v-6.56l8.68 1.05s-.14 5.64-5 7.29z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11767"
          d="M301.4 95.91l6.11 1.76.11 4.01-8.68-1.05z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11768"
          d="M307.51 97.67l-6.11-1.76-1.19 2.28a9.73 9.73 0 005.64 8.48 9.56 9.56 0 001.77-5z"
          opacity={0.2}
        />
        <path
          data-name="Path 11769"
          d="M303.81 83.94a.34.34 0 00.25-.56 3.32 3.32 0 00-2.84-1.1.33.33 0 10.11.65 2.69 2.69 0 012.24.9.34.34 0 00.24.11z"
          fill="#263238"
        />
        <path
          data-name="Path 11770"
          d="M316.59 96.73c-1 5.15-1.62 12.28 2 15.71 0 0-1.4 5.22-11 5.22-10.51 0-5.05-4.58-5.05-4.58 4.37-1.36 4.33-6.34 3.33-10.33z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11771"
          d="M320.54 115.88c.94-1.33.9-5.51-.1-6.25-1.61-1.2-8.52-1.47-17.82.67 1 4.06-1.14 6.18-1.14 6.18z"
          fill="#ffb921"
        />
        <path
          data-name="Path 11772"
          d="M351.8 353.28a2.25 2.25 0 01-1.76-.09.7.7 0 01-.16-.78.8.8 0 01.43-.49c.95-.45 3.13.44 3.23.48a.15.15 0 01.1.15.19.19 0 01-.09.15 9.081 9.081 0 01-1.75.58zm-1.15-1.12l-.19.06a.46.46 0 00-.26.29c-.09.3 0 .39.06.42.38.33 1.78 0 2.77-.37a5.63 5.63 0 00-2.38-.4z"
          fill="#407bff"
        />
        <path
          data-name="Path 11773"
          d="M353.51 352.72h-.08c-.8-.23-2.5-1.44-2.52-2.24a.56.56 0 01.43-.54.93.93 0 01.73.06c.94.48 1.54 2.43 1.56 2.51a.17.17 0 010 .17zm-2-2.49h-.08c-.2.07-.2.17-.2.22 0 .47 1.14 1.42 2 1.8a4.164 4.164 0 00-1.28-2 .58.58 0 00-.43-.02z"
          fill="#407bff"
        />
        <path
          data-name="Path 11774"
          d="M299.86 354.46c-.9 0-1.77-.12-2.06-.53a.62.62 0 010-.72.8.8 0 01.53-.39c1.17-.32 3.63 1.08 3.73 1.14a.15.15 0 01.08.17.17.17 0 01-.13.14 12.356 12.356 0 01-2.15.19zm-1.11-1.36a1 1 0 00-.32 0 .51.51 0 00-.33.23c-.12.21-.07.31 0 .37.33.45 2.1.47 3.41.28a7.609 7.609 0 00-2.76-.88z"
          fill="#407bff"
        />
        <path
          data-name="Path 11775"
          d="M302 354.27h-.07c-.85-.39-2.53-1.91-2.4-2.7 0-.19.16-.42.62-.47a1.2 1.2 0 01.92.29 4.75 4.75 0 011.1 2.71.21.21 0 01-.07.15.19.19 0 01-.1.02zm-1.72-2.85h-.1c-.3 0-.32.15-.32.19-.08.48 1.06 1.67 1.93 2.19a3.87 3.87 0 00-.93-2.16.88.88 0 00-.59-.22z"
          fill="#407bff"
        />
        <path
          data-name="Path 11776"
          d="M309.72 354.1h-7.03l-.7-16.29h7.03z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11777"
          d="M361.35 350.85l-6.87 1.49-6.91-15.18 6.88-1.48z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11778"
          d="M353.81 351.65l7.73-1.68a.61.61 0 01.68.35l2.68 5.81a1 1 0 01-.74 1.44c-2.7.54-4.05.67-7.44 1.4-2.09.45-6.81 1.6-9.7 2.23s-3.88-2.15-2.75-2.66c5.05-2.31 7.15-4.34 8.52-6.23a1.67 1.67 0 011.02-.66z"
          fill="#263238"
        />
        <path
          data-name="Path 11779"
          d="M302.74 353.29h7.68a.62.62 0 01.6.48l1.39 6.25a1 1 0 01-1 1.25c-2.77 0-6.77-.21-10.25-.21-4.08 0-7.59.23-12.37.23-2.89 0-3.69-2.92-2.48-3.19 5.5-1.2 10-1.33 14.75-4.26a3.27 3.27 0 011.68-.55z"
          fill="#263238"
        />
        <path
          data-name="Path 11780"
          d="M331.17 114c6.59 1.51 12 18.34 12 18.34L330 142.46a28.93 28.93 0 01-7-13c-2.33-8.82 1.43-16.98 8.17-15.46z"
          fill="#cf1e22"
        />
        <path
          data-name="Path 11782"
          d="M296.5 134.11c-1.64 1.78-3.28 3.36-5 5-.85.81-1.71 1.6-2.59 2.38l-1.33 1.16-.33.29c-.16.14-.36.31-.57.47a8.71 8.71 0 01-1.93 1.14 6.48 6.48 0 01-2.44.5 6 6 0 01-2.1-.37 5.91 5.91 0 01-2-1.27 6 6 0 01-1.56-2.59 6.812 6.812 0 01-.29-1.49 10.22 10.22 0 010-1.79c.05-.48.11-.89.19-1.28a24.892 24.892 0 011.16-4 36.658 36.658 0 011.55-3.61c.64-1.27 1.25-2.2 1.86-3.26a81.65 81.65 0 018.45-11.46 77.418 77.418 0 0110.25-9.72l3.68 3.79c-2.58 3.46-5.12 7.17-7.47 10.82a114.885 114.885 0 00-6.4 11.25c-.43.94-1 2-1.27 2.76a26.83 26.83 0 00-.93 2.7 17.165 17.165 0 00-.57 2.52 3.753 3.753 0 000 .4v-.1a2.819 2.819 0 00-.13-.65 4.29 4.29 0 00-1.15-1.86 4.84 4.84 0 00-3.33-1.35 4.08 4.08 0 00-1.61.31c-.49.21-.5.27-.5.24l.38-.35 1.21-1.1 2.39-2.24c1.58-1.49 3.17-3.08 4.67-4.55z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11783"
          d="M325.52 126.41c3.58 3.54 4.75 10 5 15.6l-.58.45a28.93 28.93 0 01-7-13c-.13-.53-.25-1.05-.34-1.57z"
          opacity={0.2}
        />
        <path
          data-name="Path 11784"
          d="M289.51 121.08c-1.44 7.6-2.34 23.21 1.83 54.11H329c.26-5.78-3.37-33.95 2.2-61.16a99 99 0 00-12.6-1.59 137.483 137.483 0 00-16 0c-1.76.16-3.5.42-5 .69a10 10 0 00-8.09 7.95z"
          fill="#cf1e22"
        />
        <path
          data-name="Path 11786"
          d="M295.27 132.31l-6.8-1.62c-.21 4.11-.23 9.22.07 15.53 3.13-3.57 7.13-9.12 6.73-13.91z"
          opacity={0.2}
        />
        <path
          data-name="Path 11787"
          d="M301.99 337.82l.36 8.39h7.04l-.36-8.39z"
          opacity={0.2}
        />
        <path
          data-name="Path 11788"
          d="M354.45 335.68l-6.88 1.49 3.56 7.82 6.88-1.49z"
          opacity={0.2}
        />
        <path
          data-name="Path 11789"
          d="M319.93 89.2c-1.8 6.75-2.52 10.78-6.68 13.59C307 107 299.2 102.16 299 95c-.22-6.44 2.77-16.38 10-17.74a9.52 9.52 0 0110.93 11.94z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11790"
          d="M304.15 89.46c-.34-.9-1.89-7.87-.43-9.68s18.11-.51 20.57 1.92c4.09 4 1.25 7.6-3.22 12.23-3.36 3.48-3.49 7.4-5.19 8-3 1-7.58.06-8.5-3.11s-3.23-9.36-3.23-9.36z"
          fill="#263238"
        />
        <path
          data-name="Path 11791"
          d="M322.27 73.77c-5.88-2.51-16.91.27-22.87-1.17A9.18 9.18 0 00307 82a78.13 78.13 0 0015 1.38c6.55-.3 5.27-7.48.27-9.61z"
          fill="#263238"
        />
        <path
          data-name="Path 11792"
          d="M323.19 81.91a11.16 11.16 0 006.23-1.2c1.1 2.66-4.95 3.39-6.23 1.2z"
          fill="#263238"
        />
        <path
          data-name="Path 11793"
          d="M307.35 89.74a7.88 7.88 0 01-2 4.66c-1.54 1.69-3.14.64-3.41-1.42-.24-1.85.26-5 2.14-5.89s3.4.56 3.27 2.65z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11794"
          d="M304.69 175.19s8 53.75 12.37 73.89c4.79 22 30.53 95 30.53 95l12.59-2.72s-18-59.46-22-90.29c-3.1-23.68-9.19-75.89-9.19-75.89z"
          fill="#18206b"
        />
        <path
          data-name="Path 11795"
          d="M344.57 339.89c-.05 0 2.35 4.55 2.35 4.55l14.16-3.06-1.19-4.26z"
          fill="#263238"
        />
        <path
          data-name="Path 11796"
          d="M309.74 194.34c9.23 1.81 8.25 36.23 7.14 53.93-2.66-12.51-6.56-36.59-9.22-53.68a3.15 3.15 0 012.08-.25z"
          opacity={0.3}
        />
        <path
          data-name="Path 11797"
          d="M291.34 175.19s-1 52.59-.2 74c.8 22.31 8.59 95.36 8.59 95.36h11.92s.43-71.75 1-93.66c.58-23.89 3.46-75.74 3.46-75.74z"
          fill="#18206b"
        />
        <path
          data-name="Path 11798"
          d="M297.44 339.84c-.06 0 .67 5 .67 5h14.49l.4-4.41z"
          fill="#263238"
        />
        <path
          data-name="Path 11799"
          d="M304.25 123.39c3.37 9.09-16.44 19.79-16.44 19.79l-8.58-11S285 120.77 292 115.63c8.65-6.34 9.68.84 12.25 7.76z"
          fill="#cf1e22"
        />
      </g>
      <g>
        <ellipse
          data-name="Ellipse 601"
          cx={36.09}
          cy={23}
          rx={36.09}
          ry={23}
          transform="translate(345.78 8.38)"
          fill="#ffd200"
        />
        <path
          data-name="Path 11801"
          d="M368.85 43a10.1 10.1 0 01-9.93-8.4 10.22 10.22 0 017.71-11.6 10.06 10.06 0 0110.82 4.52l23.17-4.79a3.63 3.63 0 014.24 2.5 3.49 3.49 0 01-2.67 4.31l-.6.12a.59.59 0 00-.42.31.63.63 0 000 .52l.41 1.06a1.57 1.57 0 01-.62 1.92 1.94 1.94 0 00-.89 1.42 1.57 1.57 0 01-1.21 1.39l-.47.09a1.54 1.54 0 01-1.66-.79 1.94 1.94 0 00-3.61.74 1.55 1.55 0 01-1.2 1.39l-.47.1a1.57 1.57 0 01-1.66-.8 1.93 1.93 0 00-1.39-.94 1.59 1.59 0 01-1.4-1.52v-1.14a.59.59 0 00-.24-.46.57.57 0 00-.5-.12l-7.39 1.52a10.07 10.07 0 01-7.95 8.39 9.69 9.69 0 01-2.07.26zm-2-19a9.21 9.21 0 00-7 10.42 9.1 9.1 0 0018-.51v-.36l8.15-1.7a1.59 1.59 0 011.33.31 1.62 1.62 0 01.62 1.21v1.13a.6.6 0 00.48.58 2.91 2.91 0 012.11 1.43.58.58 0 00.59.32l.46-.1a.57.57 0 00.42-.53 2.94 2.94 0 015.47-1.12.55.55 0 00.58.31l.48-.09a.56.56 0 00.41-.53 2.9 2.9 0 011.37-2.14.61.61 0 00.21-.72l-.41-1.06a1.62 1.62 0 011.18-2.17l.61-.12a2.44 2.44 0 001.61-1.13 2.47 2.47 0 00.3-1.95 2.63 2.63 0 00-3.08-1.77L377 28.64l-.18-.31a9.05 9.05 0 00-9.97-4.33zm2 15.29a6.38 6.38 0 111.3-.13 6.37 6.37 0 01-1.29.1zm0-11.81a6 6 0 00-1.11.11A5.41 5.41 0 00370 38.15a5.41 5.41 0 00-1.07-10.7z"
          fill="#fff"
        />
        <ellipse
          data-name="Ellipse 602"
          cx={11.86}
          cy={7.56}
          rx={11.86}
          ry={7.56}
          transform="translate(340.64 52.75)"
          fill="#407bff"
          opacity={0.6}
        />
        <ellipse
          data-name="Ellipse 603"
          cx={4.87}
          cy={3.1}
          rx={4.87}
          ry={3.1}
          transform="translate(328.76 64.76)"
          fill="#407bff"
          opacity={0.3}
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
